import { action, decorate, observable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { IRequestReviewUnlockForm } from '../models/RequestReviewUnlock';
import { RootStore } from './RootStore';

export default class RequestReviewUnlockStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
    }
    submitting = false;


    UnlockRequest = async (id: string, requestId: string) => {
        this.submitting = true;
        try {
            const unlockForm: IRequestReviewUnlockForm = new IRequestReviewUnlockForm(id);

            await agent.RequestReviewUnlock.unlock(unlockForm);

            runInAction('UnlockRequest', () => {
                this.rootStore.modalStore.closeModal();
            });
            await this.rootStore.requestStore.loadRequest(requestId);


        } catch (error) {
            await this.rootStore.requestStore.loadRequests();
            toast.error('problem submitting data');
        }
        finally {
            runInAction('UnlockRequest', () => {
                this.submitting = false;
            });
        }
    };
}

decorate(RequestReviewUnlockStore, {
    submitting: observable,
    UnlockRequest: action
});